import { useMemo } from 'react'

import { Box, Icon, Image, Text, Timeline } from '@fairfashion/design-system'
import moment from 'moment'

import { StatusTag } from '../../../components/StatusTag/status-tag.comp'
import { OrderProductionItem } from '../OrderProductionItem/order-production-item.comp'

import * as Styles from './order-production-step.styles'
import {
  OrderProductionStepAsset,
  OrderProductionStepProps,
} from './order-production-step.types'

export const OrderProductionStep = ({
  orderProductionStep,
}: OrderProductionStepProps) => {
  const dateIntervalString = useMemo(() => {
    let string = ''
    if (orderProductionStep.startDate) {
      string = `${moment(orderProductionStep.startDate).format('DD/MM/YYYY')}`
    }
    if (orderProductionStep.endDate) {
      string += ` - ${moment(orderProductionStep.endDate).format('DD/MM/YYYY')}`
    }

    if (!string) {
      string = '-'
    }

    return string
  }, [orderProductionStep])

  const assets = useMemo(() => {
    const _assets: OrderProductionStepAsset[] = []

    const getName = (url: string) => {
      return url.split('/').pop()?.split('?')?.[0] ?? ''
    }

    orderProductionStep?.assets?.images?.forEach((image) => {
      _assets.push({
        name: getName(image),
        url: image,
        isImage: true,
      })
    })

    orderProductionStep?.assets?.videos?.forEach((video) => {
      _assets.push({
        name: getName(video),
        url: video,
        isImage: false,
      })
    })

    return _assets
  }, [orderProductionStep])

  return (
    <Styles.StyledAccordion
      header={
        <Box
          width="100%"
          justifyContent="space-between"
          paddingRight={4}
          alignItems="center"
          flexWrap="wrap"
        >
          <Box direction="column" gap={1}>
            <Text size="medium" fontWeight={500}>
              {orderProductionStep.name}
            </Text>
            <Box gap={1}>
              <Icon name="calendar" color="grey_3" size={20} />
              <Text color="grey_3" size="small">
                {dateIntervalString}
              </Text>
            </Box>
          </Box>

          <Box gap={2}>
            <Box direction="column" gap={1}>
              <Text color="grey_3" size="small">
                Status
              </Text>
              <StatusTag />
            </Box>
          </Box>
        </Box>
      }
    >
      <Styles.AccordionContent>
        <Styles.ItemCard>
          <Text fontWeight={500}>Descrição do processo</Text>
          <Text color="grey_3" size="small">
            {orderProductionStep.description}
          </Text>
        </Styles.ItemCard>

        <Styles.ItemCard>
          <Text fontWeight={500}>Anexos</Text>
          <Box flexWrap="wrap" gap={3} flex={1}>
            {assets.map((asset, index) => (
              <Box
                gap={1}
                alignItems="center"
                width="100%"
                key={`asset-${index}`}
              >
                <a href={asset.url} target="_blank">
                  {asset.isImage ? (
                    <Styles.IconContainer>
                      <Image
                        width="32px"
                        height="32px"
                        borderRadius="4px"
                        src={asset.url}
                        objectFit="cover"
                        alt="Asset"
                      />
                    </Styles.IconContainer>
                  ) : (
                    <Styles.IconContainer>
                      <Icon name="file" size={16} />
                    </Styles.IconContainer>
                  )}

                  <Text size="small">{asset.name}</Text>
                </a>
              </Box>
            ))}
          </Box>
        </Styles.ItemCard>

        <Box width="100%" direction="column" gap={1}>
          <Text fontWeight={500}>Linha do tempo da etapa</Text>
          <Timeline
            items={orderProductionStep.items?.map((item, index) => {
              return {
                color: 'lilac',

                content: (
                  <Styles.ItemCard>
                    <OrderProductionItem
                      key={`order-production-item-${index}`}
                      orderProductionItem={item}
                    />
                  </Styles.ItemCard>
                ),
              }
            })}
          />
        </Box>
      </Styles.AccordionContent>
    </Styles.StyledAccordion>
  )
}
